import CryptoJS from 'crypto-js'

/**
 * AES 解密（CryptoJS 默认 CBC + PKCS7，与 encryptAes 配对）
 * @param {string} ciphertext Base64 密文
 * @param {string} key 密钥
 */
export function decryptAes(ciphertext, key) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, key)
  const result = bytes.toString(CryptoJS.enc.Utf8)
  if (!result) {
    throw new Error('AES 解密失败，请检查密文与密钥')
  }
  return result
}

/**
 * AES 加密，用于生成环境变量中的密文
 * @param {string} plaintext 明文
 * @param {string} key 密钥
 */
export function encryptAes(plaintext, key) {
  return CryptoJS.AES.encrypt(plaintext, key).toString()
}



// WEBPACK FOOTER //
// ./src/utils/aes.js